import React from "react"
import ReactDOM from "react-dom"
import "./index.css"
import * as serviceWorker from "./serviceWorker"

const racine = document.getElementById("root")

if (window.location.pathname.startsWith("/ecran")) {
	// Écran salle de pause : page autonome hors shell (ni Redux, ni NavV2, ni
	// bootstrap, ni socket). require() plutôt qu'import : App, le store et le
	// CSS legacy ne sont même pas évalués sur la tablette.
	const EcranPage = require("./components/ecran/EcranPage").default
	ReactDOM.render(<EcranPage />, racine)
} else {
	const App = require("./App").default
	const { Provider } = require("react-redux")
	const Store = require("./store/configureStore").default
	const ToastContainer =
		require("./components/basics/interface/ToastContainer").default
	ReactDOM.render(
		<Provider store={Store}>
			<App />
			<ToastContainer />
		</Provider>,
		racine,
	)
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
